/**
 * Delay the passed function for agiven time limit to debounce user input
 * @param {function} fn - The function to trigger after the timeout is complete
 * @param {number} limit - The length of time to wait in miliseconds
 */
const debounce = (fn, limit) => {
  let timer = null;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      fn(...args);
    }, limit);
  };
};

export default debounce;
